<template>
  <div id="app">
    <div class="container" v-if="userAgentIsSupported">
      <div style="overflow: hidden; position: relative; margin: 25px;">
        <puzzle :activeImage="activeImage" :visitor="visitor" />
      </div>
      <div style="overflow: hidden; overflow-y: auto;position: relative; margin: 25px 15px 25px 0;">
        <sidebar @activeImage="updateImage" :visitor="visitor" />
      </div>
    </div>
    <div id="browser-not-supported" v-else>
      <div>
        <p>Uw browser wordt momenteel niet gesupporteerd.</p>
        <p>Gelieve het te proberen in Chrome, Edge, Firefox of Safari</p>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue';
import Puzzle from './Puzzle.vue';

export default {
  name: 'app',
  components: {
    Sidebar,
    Puzzle
  },
  computed: {
    userAgentIsSupported() {
      if (
        navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > 0
      ) {
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      activeImage: null,
      visitor: null
    };
  },
  methods: {
    updateImage(image) {
      this.activeImage = image;
    },
    initAnalytics(code) {
      var script = document.createElement('script');
      var start = new Date();
      script.async = 1;

      var prior = document.getElementsByTagName('script')[0];
      script.onload = script.onreadystatechange = (data, error) => {
        window.ga =
          window.ga ||
          function() {
            (ga.q = ga.q || []).push(arguments);
          };
        ga.l = +new Date();
        ga('create', code, 'auto');
        ga('send', 'pageview');
        window.onbeforeunload = () => {
          var end = new Date();
          ga('send', 'event', 'Leaving', Math.round((end - start) / 1000) + ' seconds');
        };
      };

      script.src = 'https://www.google-analytics.com/analytics.js';
      prior.parentNode.insertBefore(script, prior);
    }
  },
  mounted() {
    this.initAnalytics('UA-92391903-3');
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

body,
html,
#app,
#app .container {
  height: 100vh;
  margin: 0;
}

#app {
  font-family: 'Open Sans';
  background-image: linear-gradient(
    198.75865034784223deg,
    #e46166,
    #f17458 10.7%,
    #ef785a 11%,
    #f47959 11.4%,
    #f37e5a 12%,
    #f38154 15.4%,
    #fba955 31.8%,
    #fcda81 52%,
    #e2e5ae 68.7%,
    #63bbb1
  );
}

input {
  font-family: 'Open Sans';
}

#app .container {
  display: grid;
  grid-template-columns: 5fr 1fr;
}

#browser-not-supported {
  height: 100vh;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
}

.button {
  background: #0f74bd;
  padding: 15px;
  color: white;
  border-radius: 15px;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/App.vue